import StorageServices from "../services/StorageServices";

export default function useActiveStore() {
  const store = StorageServices.get("TD-Active-Team")
    ? JSON.parse(StorageServices.get("TD-Active-Team"))
    : {};
  return store;
}
